// extracted by mini-css-extract-plugin
export var backButton = "_17-1";
export var content = "_17-d";
export var continueButton = "_17-7";
export var continueHint = "_17-8";
export var continueRow = "_17-6";
export var leftInner = "_17-0";
export var shell = "_17-e";
export var sidebarContent = "_17-5";
export var skipButton = "_17-c";
export var spacer = "_17-2";
export var spin = "_17-a";
export var spinner = "_17-9";
export var spinnerOverlay = "_17-b";
export var subtitle = "_17-4";
export var title = "_17-3";